<template>
  <v-app>
    <div id="app">
      <TheHeader />
      <v-content>
        <router-view></router-view>
      </v-content>
    </div>
  </v-app>
</template>

<script>
import TheHeader from "./components/TheHeader.vue";

export default {
  name: "app",
  components: {
    TheHeader
  }
};
</script>
